const stringExtensions = `
interface String {

/**

* Returns a nonnegative integer Number less than 1114112 (0x110000) that is the code point

* value of the UTF-16 encoded code point starting at the string element at position pos in

* the String resulting from converting this object to a String.

* If there is no element at that position, the result is undefined.

* If a valid UTF-16 surrogate pair does not begin at pos, the result is the code unit at pos.

*/

codePointAt(pos: number): number | undefined;



/**

* Returns true if searchString appears as a substring of the result of converting this

* object to a String, at one or more positions that are

* greater than or equal to position; otherwise, returns false.

* @param searchString search string

* @param position If position is undefined, 0 is assumed, so as to search all of the String.

*/

includes(searchString: string, position?: number): boolean;



/**

* Returns true if the sequence of elements of searchString converted to a String is the

* same as the corresponding elements of this object (converted to a String) starting at

* endPosition – length(this). Otherwise returns false.

*/

endsWith(searchString: string, endPosition?: number): boolean;



/**

* Returns a String value that is made from count copies appended together. If count is 0,

* the empty string is returned.

* @param count number of copies to append

*/

repeat(count: number): string;



/**

* Returns true if the sequence of elements of searchString converted to a String is the

* same as the corresponding elements of this object (converted to a String) starting at

* position. Otherwise returns false.

*/

startsWith(searchString: string, position?: number): boolean;


}

declare global {

  /**

  * This static method returns a string created by using the specified sequence of code points

  */

  interface StringConstructor {
    fromCodePoint(...numbers: number[]): string
  }
}

`
export default stringExtensions
